import React, { useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  InputAdornment,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import { Auth } from "aws-amplify";
import { useState, useContext } from "react";
import { Link } from "react-router-dom";
import awsconfig from "../../aws-exports";
import Amplify from "@aws-amplify/core";
import { withRouter } from "react-router-dom";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { AuthContext } from "../../Context/Auth";
import { Instance } from "../../Context/axiosContext";
import LoadingScreen from "../../Shared/LoadingScreen";
import MultiRestLogin from "../RestLogin/MultiRestLogin";
import { VisibilityOffOutlined, VisibilityOutlined } from "@material-ui/icons";
import axios from "axios";
import { RestaurantContext } from "../../Context/RestaurantData";
import { ApiContext } from "../../Context/ApiKey";
import { RouteContext } from "../../Context/RouteContext";
Amplify.configure(awsconfig);

const useStyles = makeStyles({
  img: {
    width: "100%",
    height: "100vh",
    backgroundSize: "cover",
  },
  form: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  },
  input: {
    marginTop: "30px",
    width: "50%",
  },
  button: {
    width: "50%",
    marginTop: "30px",
    backgroundColor: "#5555b2",
    color: "white",
    fontWeight: "500",
    height: "50px",
  },
  linkDiv: {
    width: "50%",
  },
  inputIcon: {
    backgroundColor: "yellow",
  },
  adminCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  para: {
    fontWeight: "lighter",
    fontSize: "22px",
  },
  link: {
    cursor: "pointer",
    float: "right",
  },
  textBox: {
    textAlign: "center",
    fontSize: "40px",
    height: "30vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});

const initialFormState = {
  email: "",
  password: "",
  newPassword: "",
  cpassword: "",
  formType: "signIn",
};

const Login = ({ history }) => {
  const { ApiKey } = useContext(ApiContext);
  const { inMemRoute } = useContext(RouteContext);
  const { setRestaurantData } = useContext(RestaurantContext);
  const axiosInstance = Instance();
  const [isPassDiff, setIsPassDiff] = useState();
  const [showPass, setShowPass] = useState({
    loginPass: false,
    newPass: false,
    cNewPass: false,
  });
  const [snackOpen, setSnackOpen] = useState({ open: false, message: "" });
  const [isValid, setIsValid] = useState({
    email: {
      valid: true,
      error: "",
    },
    password: {
      valid: true,
      error: "",
    },
    newPassword: {
      valid: true,
      error: "",
    },
    cpassword: {
      valid: true,
      error: "",
    },
  });
  const isValidHanlder = (name, value) => {
    let emailRegex = new RegExp("[a-zA-Z0-9]+@[a-zA-Z]+.[a-zA-Z]{2,3}");
    switch (name) {
      case "email":
        if (value.length < 3) {
          setIsValid({
            ...isValid,
            email: { valid: false, error: "Invalid Input!" },
          });
        } else if (!emailRegex.test(value)) {
          setIsValid({
            ...isValid,
            email: { valid: false, error: "Invalid Email!" },
          });
        } else {
          setIsValid({
            ...isValid,
            email: { valid: true, error: "" },
          });
        }
        break;
      case "password":
        if (value.length < 3) {
          setIsValid({
            ...isValid,
            password: { valid: false, error: "Invalid Password!" },
          });
        } else if (value.length < 8) {
          setIsValid({
            ...isValid,
            password: {
              valid: false,
              error: "Password must be 8 character long!",
            },
          });
        } else {
          setIsValid({
            ...isValid,
            password: { valid: true, error: "" },
          });
        }
        break;
      case "newPassword":
        if (value.length < 3) {
          setIsValid({
            ...isValid,
            newPassword: {
              valid: false,
              error: "Invalid Password!",
            },
          });
        } else if (value.length < 8) {
          setIsValid({
            ...isValid,
            newPassword: {
              valid: false,
              error: "Password must be 8 character long!",
            },
          });
        } else {
          setIsValid({
            ...isValid,
            newPassword: { valid: true, error: "" },
          });
        }
        break;
      case "cpassword":
        if (value.length < 3) {
          setIsValid({
            ...isValid,
            cpassword: { valid: false, error: "Invalid Password!" },
          });
        } else if (value.length < 8) {
          setIsValid({
            ...isValid,
            cpassword: {
              valid: false,
              error: "Password must be 8 character long!",
            },
          });
        } else if (value !== formState.newPassword) {
          setIsValid({
            ...isValid,
            cpassword: {
              valid: false,
              error: "Password should be same!",
            },
          });
        } else {
          setIsValid({
            ...isValid,
            cpassword: { valid: true, error: "" },
          });
        }
        break;
      default:
        return;
    }
  };

  const { login } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);

  let apikey = localStorage.getItem("apikey");

  const autoLoginHandler = async (idToken) => {
    try {
      const res = await fetch(
        process.env.REACT_APP_API_URL + `restaurant/multi/switch`,
        {
          headers: {
            Authorization: idToken,
            ["x-api-key"]: ApiKey ? ApiKey : apikey,
          },
        }
      );
      const data = await res.json();

      if (data.multiple === true) {
        history.push("/multiLogin");
        // if api key exist go to the dashboard in the last routed page
        if (apikey) {
          login(idToken);
          history.push(inMemRoute);
        }
      } else {
        login(idToken);
        localStorage.setItem("apikey", data.restaurants[0].api_key);
        history.push(inMemRoute);
      }
    } catch (err) {
      console.log("err****", err);
    }
  };

  //Checking if user is already logged in or not
  useEffect(() => {
    Auth.currentSession()
      .then((data) => {
        if (data) {
          setLoading(true);
          if (data.getIdToken().payload["custom:Role"] === "RestAdmin") {
            localStorage.setItem(
              "COgnitoRole",
              data.getIdToken().payload["custom:Role"]
            );
          } else {
            const Distr = JSON.parse(
              data.getIdToken().payload["custom:rest"]
            ).customClaimValue;
            localStorage.setItem("COgnitoRole", JSON.stringify(Distr));
          }
          let idToken = data.getIdToken().getJwtToken();
          autoLoginHandler(idToken);
        }
      })
      .catch((err) => console.log("not logged in"));
    return () => {
      setLoading(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleModalClose = () => {
    setModalOpen(!modalOpen);
  };

  const [formType, setFormType] = useState("signIn");

  const [formState, updateFormState] = useState(initialFormState);
  const classes = useStyles();

  function onChange(e) {
    isValidHanlder(e.target.name, e.target.value);
    updateFormState(() => ({
      ...formState,
      [e.target.name]: e.target.value,
    }));
  }

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const [restData, setRestData] = useState([]);
  const checkIfMultipleRestrauntOwner = async (user) => {
    console.log("signin", user);
    try {
      const { data } = await axios.get(
        process.env.REACT_APP_API_URL + `restaurant/multi/switch`,
        {
          headers: {
            Authorization: user?.signInUserSession?.idToken?.jwtToken,
          },
        }
      );
      setRestData(data.restaurants);
      localStorage.setItem("restaurants", JSON.stringify(data.restaurants));
      localStorage.setItem("isMultiOwner", data.multiple);
      localStorage.setItem("apikey", data.restaurants[0].api_key);
      if (data.multiple === true) {
        history.push("/select-restaurant");
      } else {
        if (
          user.signInUserSession.idToken.payload["custom:Role"] ===
          "RestAdmin"
        ) {
          localStorage.setItem(
            "COgnitoRole",
            user.signInUserSession.idToken.payload["custom:Role"]
          );
        } else {
          const Distr = JSON.parse(
            user.signInUserSession.idToken.payload["custom:rest"]
          ).customClaimValue;
          localStorage.setItem("COgnitoRole", JSON.stringify(Distr));
        }
        login(user.signInUserSession.idToken.jwtToken);
        localStorage.setItem("isMultiOwner", data.restaurants[0].api_key);
        history.push("/");
      }
    } catch (err) {
      console.log("err****", err);
    }
  };

  async function signIn(e) {
    e.preventDefault();

    const { email, password } = formState;
    if (checkValid().valueOf(true)) {
      setLoading(true);
      Auth.signIn(email.toLowerCase(), password)
        .then((user) => {
          if (user) {
            checkIfMultipleRestrauntOwner(user);
          }
          if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
            setFormType("challenge");
          }

          //  else {
          // 	login(user.signInUserSession.idToken.jwtToken);
          // 	history.push('/');
          // }
        })
        .catch((err) => {
          console.log("error login", err);
          SnackOpenHandler(err.message);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      SnackOpenHandler("Invalid Username or password!");
    }
  }
  const SnackOpenHandler = (message) => {
    setSnackOpen({ open: true, message });
  };

  const SnackCloseHandler = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen({ open: false, message: "" });
  };
  const checkValid = () => {
    if (
      formState.email.length < 1 ||
      formState.password.length < 1 ||
      !isValid.email.valid ||
      !isValid.password.valid
    ) {
      return false;
    } else {
      return true;
    }
  };
  const checkValidNewUser = () => {
    if (
      formState.newPassword.length < 1 ||
      formState.cpassword.length < 1 ||
      !isValid.newPassword.valid ||
      !isValid.cpassword.valid
    ) {
      return false;
    } else {
      return true;
    }
  };
  function challengePass(e) {
    e.preventDefault();
    const { email, password, newPassword, cpassword } = formState;
    if (checkValidNewUser().valueOf(true)) {
      setLoading(true);
      Auth.signIn(email.toLowerCase(), password)
        .then((user) => {
          if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
            if (newPassword === cpassword) {
              Auth.completeNewPassword(
                user, // the Cognito User Object
                newPassword // the new password
              )
                .then((user) => {
                  checkIfMultipleRestrauntOwner(user);
                  setLoading(false);
                  // login(user.signInUserSession.idToken.jwtToken);
                  // history.push("/");
                })
                .catch((e) => {
                  setLoading(false);
                  SnackOpenHandler(e.message);
                });
            } else {
              console.log("Invalid credentials");
            }
          }
        })
        .catch((e) => {
          SnackOpenHandler(e.message);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      SnackOpenHandler("Invalid Password!");
    }
  }
  return (
    <>
      {formType === "signIn" && (
        <Grid container>
          <Grid item sm={12} xs={12} md={6} lg={6}>
            <Typography className={classes.textBox}>
              Hello Corp
              <br />
              Welcome Back
            </Typography>

            <form
              onSubmit={signIn}
              className={classes.form}
              noValidate
              autoComplete="off"
            >
              <TextField
                className={classes.input}
                label="Email"
                inputProps={{
                  "aria-label": "email",
                }}
                error={!isValid.email.valid}
                helperText={!isValid.email.valid && isValid.email.error}
                type="text"
                name="email"
                onChange={onChange}
                variant="outlined"
                required
                autoComplete="email"
              />
              <TextField
                className={classes.input}
                label="Password"
                type={showPass.loginPass ? "text" : "password"}
                name="password"
                onChange={onChange}
                variant="outlined"
                error={!isValid.password.valid}
                helperText={!isValid.password.valid && isValid.password.error}
                required
                autoComplete="off"
                inputProps={{
                  "aria-label": "password",
                }}
                InputProps={{
                  endAdornment: formState.password.length > 0 && (
                    <InputAdornment classes={classes.inputIcon} position="end">
                      {!showPass.loginPass ? (
                        <VisibilityOutlined
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            setShowPass({ ...showPass, loginPass: true })
                          }
                        />
                      ) : (
                        <VisibilityOffOutlined
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            setShowPass({ ...showPass, loginPass: false })
                          }
                        />
                      )}
                    </InputAdornment>
                  ),
                }}
              />
              <div className={classes.linkDiv}>
                <Link to="/forgot-password" className={classes.link}>
                  Forgot Password?
                </Link>
              </div>

              {modalOpen && restData && (
                <MultiRestLogin
                  restaurants={restData}
                  modalOpen={modalOpen}
                  handleModalClose={handleModalClose}
                />
              )}

              <Button
                className={classes.button}
                variant="contained"
                color="primary"
                type="submit"
                aria-label="loginButton"
              >
                Login
              </Button>

              <Snackbar
                open={snackOpen.open}
                autoHideDuration={6000}
                onClose={SnackCloseHandler}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
              >
                <Alert onClose={SnackCloseHandler} severity="error">
                  {snackOpen.message}
                </Alert>
              </Snackbar>
            </form>
          </Grid>
          <Grid item lg={6} md={6}>
            <Box display={{ xs: "none", md: "block", lg: "block" }}>
              <img
                className={classes.img}
                src="https://images.unsplash.com/photo-1616277434251-0e5188ccbe00?ixid=MXwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwyfHx8ZW58MHx8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
                alt="images"
              />
            </Box>
          </Grid>
        </Grid>
      )}
      {formType === "challenge" && (
        <Grid container>
          <Grid item sm={12} xs={12} md={6} lg={6}>
            <Typography className={classes.textBox}>
              Enter a New Password
            </Typography>
            <form
              onSubmit={challengePass}
              className={classes.form}
              noValidate
              autoComplete="off"
            >
              <TextField
                className={classes.input}
                value={formState.email}
                disabled
                type="text"
                inputProps={{
                  "aria-label": "email",
                }}
                onChange={onChange}
                variant="outlined"
                required
              />
              <TextField
                className={classes.input}
                label="New Passsword"
                type={showPass.newPass ? "text" : "password"}
                name="newPassword"
                inputProps={{
                  "aria-label": "newPassword",
                }}
                onChange={onChange}
                error={!isValid.newPassword.valid}
                helperText={
                  !isValid.newPassword.valid && isValid.newPassword.error
                }
                variant="outlined"
                required
                autoComplete="email"
                InputProps={{
                  endAdornment: formState.newPassword.length > 0 && (
                    <InputAdornment classes={classes.inputIcon} position="end">
                      {!showPass.newPass ? (
                        <VisibilityOutlined
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            setShowPass({ ...showPass, newPass: true })
                          }
                        />
                      ) : (
                        <VisibilityOffOutlined
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            setShowPass({ ...showPass, newPass: false })
                          }
                        />
                      )}
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                className={classes.input}
                label="Confirm Password"
                type={showPass.cNewPass ? "text" : "password"}
                name="cpassword"
                inputProps={{
                  "aria-label": "cNewPassword",
                }}
                onChange={onChange}
                variant="outlined"
                error={!isValid.cpassword.valid}
                helperText={!isValid.cpassword.valid && isValid.cpassword.error}
                required
                autoComplete="off"
                InputProps={{
                  endAdornment: formState.cpassword.length > 0 && (
                    <InputAdornment classes={classes.inputIcon} position="end">
                      {!showPass.cNewPass ? (
                        <VisibilityOutlined
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            setShowPass({ ...showPass, cNewPass: true })
                          }
                        />
                      ) : (
                        <VisibilityOffOutlined
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            setShowPass({ ...showPass, cNewPass: false })
                          }
                        />
                      )}
                    </InputAdornment>
                  ),
                }}
              />

              <Button
                className={classes.button}
                variant="contained"
                color="primary"
                type="submit"
                aria-label="loginNewButtton"
              >
                Login
              </Button>

              <Snackbar
                open={snackOpen.open}
                autoHideDuration={6000}
                onClose={SnackCloseHandler}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
              >
                <Alert onClose={SnackCloseHandler} severity="error">
                  {snackOpen.message}
                </Alert>
              </Snackbar>
            </form>
          </Grid>
          <Grid item lg={6} md={6}>
            <Box display={{ xs: "none", md: "block", lg: "block" }}>
              <img
                className={classes.img}
                src="https://images.unsplash.com/photo-1616277434251-0e5188ccbe00?ixid=MXwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwyfHx8ZW58MHx8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
                alt="images"
              />
            </Box>
          </Grid>
        </Grid>
      )}
      {loading && <LoadingScreen loading={loading} loaderColor="secondary" />}
    </>
  );
};

export default withRouter(Login);
